import { Fragment, ReactElement } from 'react';
import cn from 'classnames';

import styles from './RecalculateButton.module.scss';
import cms from '../../data/cms.json';

import { Icon } from '../Icon/Icon';
import { getDataTest } from '../../utils/dataTests';
import { Button } from '../Button/Button';

interface RecalculateButtonProps {
    onClick: () => void;
    loading?: boolean;
    className?: string;
}

export const RecalculateButton = ({
    onClick,
    className,
    loading,
    ...props
}: RecalculateButtonProps): ReactElement | null => {
    return (
        <Button
            variant="secondary"
            className={cn(styles.wrapper, loading && styles.isLoading, className)}
            onClick={onClick}
        >
            <Fragment>
                <Icon className={styles.icon} size="medium" name="refresh" data-test={getDataTest(props, 'Icon')} />{' '}
                {cms.common.recalculateButton}
            </Fragment>
        </Button>
    );
};
